import { useUnit } from 'effector-react';
import { Controller, useFormContext } from 'react-hook-form';
import { $transferRequestsDeleteFileStore } from '@lib/store';
import { cn, PaymentUtils } from '@shared/utils';
import { type CustomFile, FileUpload, type FileWithId, Spinner } from '@shared/widgets';

export interface FilesFormData {
  files: (FileWithId | CustomFile)[];
}

interface FilesFromBlockProps {
  className?: string;
  transactionId?: string;
}

export const FilesFormBlock = (props: FilesFromBlockProps) => {
  const { loading } = useUnit($transferRequestsDeleteFileStore.store);

  const { control } = useFormContext<FilesFormData>();

  return (
    <div className={cn(props.className)}>
      {loading && <Spinner position />}
      <Controller
        name='files'
        control={control}
        render={({ field: { value, onChange } }) => (
          <FileUpload
            label='Supporting documents'
            multiple
            value={value}
            onChange={onChange}
            onDelete={async (file) => {
              const files = await PaymentUtils.deletePaymentDocument({ transferRequestId: props.transactionId, files: value, file });
              onChange(files);
            }}
          />
        )}
      />
    </div>
  );
};
